import { gql } from '@apollo/client';

export const NOTE = gql`
  query getNote($cartId: ID!) {
    cart(id: $cartId) {
      ... on Cart {
        id
        note
        __typename
      }
    }
  }
`;

export default {};
